import React, { Component } from 'react'
import axios from "axios";
//import { ReactTransliterate, TriggerKeys } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import Path from "./config";
import AdminNavFormProfile from './AdminNavFormProfile';
//import PaymentOneTwenty from './paymentOneTwenty';

export class PostAddress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            relationWith: [],
            sbg_post_full_name: '',
            sbg_post_full_address: '',
            sbg_post_pincode: '',
            sbg_post_state: '',
            sbg_post_district: '',
            sbg_post_taluka: '',
            sbg_post_place: '',
            sbg_post_state1: '',
            sbg_post_district1: '',
            sbg_post_taluka1: '',
            sbg_post_place1: '',
            sbg_post_mobileno: '',
            phonelength: "0",
            NavMenu: false,
            stateSelect: [],
            districtSelect: [],
            talukaSelect: [],
            placeSelect: [],
            stateSelect1: [],
            districtSelect1: [],
            talukaSelect1: [],
            placeSelect1: [],
            collection: [],
            sbg_post_collection: '',
            selectType: '',
            courier: false,
            pickup: false,
            sbg_suchi_delivery_type: '',
            sbg_suchi_delivery_payment: '',
            notNow: false,
            scc_address: '',
            scc_map_link: '',
            scc_mobile_no1: '',
            scc_name: '',
            scc_person_name: '',
            selectedSuchi: false,

            suchi_curier_fee: '',
            suchi_fee_status: '',
            suchi_nondani_fee: '',
            suchi_suchi_fee: '',
            suchi_suchifee_status: '',
            feeType: 'nondani'
        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }




        //state dropdown 
        axios.get(Path + 'stateList.php')
            .then(function (response) {
                this.setState({ stateSelect: response.data.bg_state })
            }.bind(this))

        axios.get(Path + 'suchi_collection_stateList.php')
            .then(function (response) {
                this.setState({ stateSelect1: response.data.bg_state })
            }.bind(this))


        axios.get(Path + 'Show_bride_groom_postalinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;

                this.setState({
                    sbg_post_full_name: response.sbg_post_full_name,
                    sbg_post_full_address: response.sbg_post_full_address,
                    sbg_post_pincode: response.sbg_post_pincode,
                    sbg_post_state: response.sbg_post_state,
                    sbg_post_district: response.sbg_post_district,
                    sbg_post_taluka: response.sbg_post_taluka,
                    sbg_post_place: response.sbg_post_place,
                    sbg_suchi_delivery_type: response.sbg_suchi_delivery_type,
                    sbg_post_mobileno: response.sbg_post_mobileno,
                    phonelength: response.sbg_post_mobileno.length,
                    sbg_suchi_delivery_payment: response.sbg_suchi_delivery_payment
                })

                if (response.sbg_post_state) {
                    axios.get(Path + 'districtList.php?bs_id=' + response.sbg_post_state)
                        .then(function (response) {
                            this.setState({ districtSelect: response.data.bg_district })
                        }.bind(this))
                }
                if (response.sbg_post_district) {
                    axios.get(Path + 'talukaList.php?bd_id=' + response.sbg_post_district)
                        .then(function (response) {
                            this.setState({ talukaSelect: response.data.bg_taluka })
                        }.bind(this))
                }
                if (response.sbg_post_taluka) {
                    axios.get(Path + 'placeList.php?bt_id=' + response.sbg_post_taluka)
                        .then(function (response) {
                            this.setState({ placeSelect: response.data.bg_place })
                        }.bind(this))
                }
            }.bind(this))


        axios.get(Path + 'Show_bride_groom_pickup.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                if (response.data.collection_cntre) {
                    response = response.data.collection_cntre[0];
                    if (response.sbg_suchi_delivery_type === '1') {
                        this.setState({
                            courier: false,
                            pickup: true, notNow: false
                        })
                    } else if (response.sbg_suchi_delivery_type === '0') {
                        this.setState({
                            courier: true,
                            pickup: false, notNow: false
                        })
                    } else if (response.sbg_suchi_delivery_type === '2') {
                        this.setState({
                            courier: false,
                            pickup: false, notNow: true
                        })
                    }
                }
                this.setState({
                    sbg_post_state1: response.fk_state_id,
                    sbg_post_district1: response.fk_district_id,
                    sbg_post_taluka1: response.fk_taluka_id,
                    // sbg_post_place1:response.fk_place_id,
                    sbg_post_collection: response.scc_id,
                    sbg_suchi_delivery_type: response.sbg_suchi_delivery_type,

                })

                if (response.fk_state_id) {
                    axios.get(Path + 'suchi_collection_districtList.php?bs_id=' + response.fk_state_id)
                        .then(function (response) {
                            // console.log("response",response)
                            this.setState({ districtSelect1: response.data.bg_district })
                        }.bind(this))
                }
                if (response.fk_district_id) {
                    axios.get(Path + 'suchi_collection_talukaList.php?bd_id=' + response.fk_district_id)
                        .then(function (response) {
                            this.setState({ talukaSelect1: response.data.bg_taluka })
                        }.bind(this))
                }

                if (response.fk_taluka_id) {
                    axios.get(Path + 'suchi_collection_centre_list.php?bplace_id=' + response.fk_taluka_id)
                        .then(function (response) {
                            this.setState({ collection: response.data.collection_cntre })
                        }.bind(this))
                }

                if (response.scc_id) {
                    axios.get(Path + 'suchi_collection_centre_details.php?scc_id=' + response.scc_id)
                        .then(function (response) {
                            response = response.data.collection_cntre[0];
                            // console.log("scc",response.data.collection_cntre[0])
                            this.setState({
                                selectedSuchi: true,
                                scc_address: response.scc_address,
                                scc_map_link: response.scc_map_link,
                                scc_mobile_no1: response.scc_mobile_no1,
                                scc_name: response.scc_name,
                                scc_person_name: response.scc_person_name,

                            })
                        }.bind(this))
                }

            }.bind(this))
        axios.get(Path + 'suchi_fee_manage_view.php')
            .then(function (response) {
                this.setState({
                    suchi_curier_fee: response.data.suchi_curier_fee,
                    suchi_fee_status: response.data.suchi_fee_status,
                    suchi_nondani_fee: response.data.suchi_nondani_fee,
                    suchi_suchi_fee: response.data.suchi_suchi_fee,
                    suchi_suchifee_status: response.data.suchi_suchifee_status,
                    amount: response.data.suchi_nondani_fee
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }

    nameHandler = (e) => {
        document.getElementById("sbg_post_full_name").style.borderColor = "";
        this.setState({ sbg_post_full_name: e.target.value });
    }

    addHandler = (e) => {
        document.getElementById("sbg_post_full_address").style.borderColor = "";
        this.setState({ sbg_post_full_address: e.target.value });
    }

    pincodeHandler = (e) => {
        document.getElementById("sbg_post_pincode").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_post_pincode: e.target.value })
        }
    }


    mobileHandler = (e) => {
        document.getElementById("sbg_post_mobileno").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_post_mobileno: e.target.value }, () => {
                this.setState({ phonelength: this.state.sbg_post_mobileno.length })

            })
        }
    }

    submitClick = (e) => {
        e.preventDefault();
        let isValid = true;

        if (this.state.sbg_post_full_name === "") {
            document.getElementById("sbg_post_full_name").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_full_address === "") {
            document.getElementById("sbg_post_full_address").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_pincode === "") {
            document.getElementById("sbg_post_pincode").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_state === "") {
            document.getElementById("sbg_post_state").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_district === "") {
            document.getElementById("sbg_post_district").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_taluka === "") {
            document.getElementById("sbg_post_taluka").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_place === "") {
            document.getElementById("sbg_post_place").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_mobileno === "") {
            document.getElementById("sbg_post_mobileno").style.borderColor = "red";
            isValid = false;
        }
        else if (this.state.phonelength < 10) {
            isValid = false;
            document.getElementById("sbg_post_mobileno").style.borderColor = "red";
        }
        let typee = "postaddress";
        let tempStr = "sbg_post_full_name=" + this.state.sbg_post_full_name +
            "&sbg_post_full_address=" + this.state.sbg_post_full_address +
            "&sbg_post_pincode=" + this.state.sbg_post_pincode +
            "&sbg_post_state=" + this.state.sbg_post_state +
            "&sbg_post_district=" + this.state.sbg_post_district +
            "&sbg_post_taluka=" + this.state.sbg_post_taluka +
            "&sbg_post_place=" + this.state.sbg_post_place +
            "&sbg_post_mobileno=" + this.state.sbg_post_mobileno +
            "&sbg_id=" + this.state.userId +
            "&type=" + typee
        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    if (response.data.status === "updated") {
                        if (this.state.admin === "Admin") {
                            this.props.history.push(`/AdminProfile/Nondani`);
                        }
                        else {
                            this.props.history.push(`/FormProfile/PaymentOneTwenty`);
                        }
                    }
                }.bind(this))
        } else {
            document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी.";
        }
    }

    submitClick1 = (e) => {
        e.preventDefault();
        let isValid = true;

        if (this.state.sbg_post_state1 === "" || this.state.sbg_post_state1 === undefined) {
            document.getElementById("sbg_post_state1").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_district1 === "" || this.state.sbg_post_state1 === undefined) {
            document.getElementById("sbg_post_district1").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_taluka1 === "" || this.state.sbg_post_state1 === undefined) {
            document.getElementById("sbg_post_taluka1").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_post_collection === "" || this.state.sbg_post_collection === undefined) {
            document.getElementById("sbg_post_collection1").innerHTML = "Select Collection Centre";
            isValid = false;
        }

        let typee = "pickupaddress";
        let tempStr = "scc_id=" + this.state.sbg_post_collection +
            "&sbg_id=" + this.state.userId +
            "&type=" + typee

        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    if (response.data.status === "updated") {
                        alert("Updated Successfully");

                        if (this.state.admin === "Admin") {
                            this.props.history.push(`/AdminProfile/Paddress`);
                        }
                        else {
                            this.props.history.push(`/FormProfile/Paddress`);
                        }
                    }
                }.bind(this))
        } else {
            //alert ("Please fill up all compalsary fields");
            document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी.";
        }
    }
    submitSkip = (e) => {
        e.preventDefault();

        let typee = "not_now_suchi";
        let tempStr = "sbg_id=" + this.state.userId +
            "&type=" + typee


        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                if (response.data.status === "updated") {
                    alert("Updated Successfully");

                    if (this.state.admin === "Admin") {
                        this.props.history.push(`/AdminProfile/Paddress`);
                    }
                    else {
                        this.props.history.push(`/FormProfile/Paddress`);
                    }
                }
            }.bind(this))

    }

    stateHandler = (e) => {
        document.getElementById("sbg_post_state").style.borderColor = "";
        this.setState
            ({ sbg_post_state: e.target.value });

        axios.get(Path + 'districtList.php?bs_id=' + e.target.value)
            .then(function (response) {
                if (!response.data.bg_district) {
                    alert("No data to display");
                    this.setState({
                        districtSelect: [],
                        talukaSelect: [],
                        sbg_post_district: '',
                        sbg_post_taluka: '',
                        placeSelect: [],
                        sbg_post_place: ''
                    })
                }
                else {
                    this.setState(
                        {
                            districtSelect: response.data.bg_district,
                            talukaSelect: [],
                            sbg_post_district: '',
                            sbg_post_taluka: '',
                            placeSelect: [],
                            sbg_post_place: '',

                        })
                }
            }.bind(this))

    }
    districtHandler = (e) => {
        document.getElementById("sbg_post_district").style.borderColor = "";
        this.setState
            ({ sbg_post_district: e.target.value });

        axios.get(Path + 'talukaList.php?bd_id=' + e.target.value)
            .then(function (response) {
                if (!response.data.bg_taluka) {
                    alert("No data to display");
                    this.setState({
                        talukaSelect: [],
                        sbg_post_taluka: '',
                        placeSelect: [],
                        sbg_post_place: ''
                    })
                } else {
                    this.setState({
                        talukaSelect: response.data.bg_taluka, placeSelect: [],
                        sbg_post_place: '', sbg_post_taluka: ''
                    })
                }
            }.bind(this))

    }
    talukaHandler = (e) => {
        document.getElementById("sbg_post_taluka").style.borderColor = "";
        this.setState
            ({ sbg_post_taluka: e.target.value });

        axios.get(Path + 'placeList.php?bt_id=' + e.target.value)
            .then(function (response) {
                if (!response.data.bg_place) {
                    alert("No data to display");
                    this.setState({
                        placeSelect: [],
                        sbg_post_place: ''
                    })
                } else {
                    this.setState({ placeSelect: response.data.bg_place, sbg_post_place: '' })
                }
            }.bind(this))

    }
    placeHandler = (e) => {
        document.getElementById("sbg_post_place").style.borderColor = "";
        this.setState
            ({ sbg_post_place: e.target.value });
    }


    stateHandler1 = (e) => {
        document.getElementById("sbg_post_state1").style.borderColor = "";
        this.setState
            ({ sbg_post_state1: e.target.value });

        axios.get(Path + 'suchi_collection_districtList.php?bs_id=' + e.target.value)
            .then(function (response) {
                if (!response.data.bg_district) {
                    alert("No data to display");
                    this.setState({
                        districtSelect1: [],
                        talukaSelect1: [],
                        sbg_post_district1: '',
                        sbg_post_taluka1: '',
                        placeSelect1: [],
                        sbg_post_place1: '',
                        collection: [],
                        sbg_post_collection: ''
                    })
                }
                else {
                    this.setState(
                        {
                            districtSelect1: response.data.bg_district,
                            talukaSelect1: [],
                            sbg_post_district1: '',
                            sbg_post_taluka1: '',
                            placeSelect1: [],
                            sbg_post_place1: '',
                            collection: [],
                            sbg_post_collection: ''
                        })
                }
            }.bind(this))

    }
    districtHandler1 = (e) => {
        document.getElementById("sbg_post_district1").style.borderColor = "";
        this.setState
            ({ sbg_post_district1: e.target.value });
        //district dropdown 

        axios.get(Path + 'suchi_collection_talukaList.php?bd_id=' + e.target.value)
            .then(function (response) {
                if (!response.data.bg_taluka) {
                    alert("No data to display");
                    this.setState({
                        talukaSelect1: [],
                        sbg_post_taluka1: '',
                        placeSelect1: [],
                        sbg_post_place1: '',
                        collection: [],
                        sbg_post_collection: ''
                    })
                } else {
                    this.setState({
                        talukaSelect1: response.data.bg_taluka, placeSelect1: [],
                        sbg_post_place1: '', sbg_post_taluka1: '', collection: [],
                        sbg_post_collection: ''
                    })
                }
            }.bind(this))

    }
    talukaHandler1 = (e) => {
        document.getElementById("sbg_post_taluka1").style.borderColor = "";
        this.setState
            ({ sbg_post_taluka1: e.target.value });


        axios.get(Path + 'suchi_collection_centre_list.php?bplace_id=' + e.target.value)
            .then(function (response) {

                if (!response.data.collection_cntre) {
                    alert("No data to display");
                    this.setState({
                        collection: [],
                        sbg_post_collection: ''
                    })
                } else {
                    this.setState({ collection: response.data.collection_cntre, sbg_collection: '' })
                }
            }.bind(this))
    }


    typeHandler = (e) => {
        this.setState
            ({ selectType: e.target.value }, () => {

                if (this.state.selectType === "pickup") {
                    this.setState({
                        courier: false,
                        pickup: true,
                        notNow: false
                    })
                }
                else if (this.state.selectType === "notNow") {
                    this.setState({
                        notNow: true,
                        courier: false,
                        pickup: false
                    })
                } else {
                    this.setState({
                        notNow: false,
                        courier: true,
                        pickup: false
                    })
                }
            })
    }
    center_handler = (e) => {
        this.setState
            ({ sbg_post_collection: e.target.value })
    }
    render() {

        let stateList = this.state.stateSelect.map((bloodg, index) => {
            const { bs_id, e_bs_statename } = bloodg //destructuring
            return (
                <option key={bs_id} value={bs_id}> {e_bs_statename} </option>
            )
        })


        let districtList = this.state.districtSelect.map((bloodg, index) => {
            const { bd_id, e_bd_districtname } = bloodg //destructuring
            return (
                <option key={bd_id} value={bd_id} >  {e_bd_districtname} </option>
            )
        })
        let talukaList = this.state.talukaSelect.map((bloodg, index) => {
            const { bt_id, e_bt_talukaname } = bloodg //destructuring
            return (
                <option key={bt_id} value={bt_id} > {e_bt_talukaname} </option>
            )
        })

        let placeList = this.state.placeSelect.map((bloodg, index) => {
            const { bp_id, e_bp_placename } = bloodg //destructuring
            return (
                <option key={bp_id} value={bp_id} > {e_bp_placename} </option>
            )
        })
        let stateList1 = this.state.stateSelect1.map((bloodg, index) => {
            const { bs_id, e_bs_statename } = bloodg //destructuring
            return (
                <option key={bs_id} value={bs_id}> {e_bs_statename} </option>
            )
        })
        let districtList1 = this.state.districtSelect1.map((bloodg, index) => {
            const { bd_id, e_bd_districtname } = bloodg //destructuring
            return (
                <option key={bd_id} value={bd_id} >  {e_bd_districtname} </option>
            )
        })
        let talukaList1 = this.state.talukaSelect1.map((bloodg, index) => {
            const { bt_id, e_bt_talukaname } = bloodg //destructuring
            return (
                <option key={bt_id} value={bt_id} > {e_bt_talukaname} </option>
            )
        })


        let collectionList = this.state.collection.map((bloodg, index) => {

            const { scc_id, scc_name, scc_person_name, scc_mobile_no1, scc_address, scc_map_link } = bloodg //destructuring
            return (

                <tr>
                    <td key={scc_id}><input type='radio' checked={this.state.sbg_post_collection === scc_id} name='collection_center' onChange={this.center_handler} value={scc_id} /></td>
                    <td>{scc_name}</td>
                    <td>{scc_person_name}</td>
                    <td>{scc_mobile_no1}</td>
                    <td><a href={scc_map_link} target='_blank' rel="noreferrer">Google Map</a></td>
                    <td>{scc_address}</td>
                </tr>

            )
        })
        return (
            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    <div> <b >  टीप : "आपल्याला वधू वर सूची मिळण्यासाठी खालील पैकी योग्य असलेला पर्याय निवडावा." </b> </div><br></br>
                    <div className="row g-3 border-black ">
                        <div className="col-md-12 p-3">
                            <div className="form-check form-check-inline col-md-12 ">

                                <input className="form-check-input" type="radio"
                                    name="selectType" value="pickup" onChange={this.typeHandler}
                                    id="inlineRadio2"
                                    style={{
                                        appearance: "none", // remove default radio styling
                                        WebkitAppearance: "none",
                                        MozAppearance: "none",
                                        width: "20px",
                                        height: "20px",
                                        border: "2px solid #000", // dark border
                                        borderRadius: "50%",
                                        outline: "none",
                                        cursor: "pointer",
                                        position: "relative",
                                    }} />
                                <span className="d-block p-2 bg-secondary text-white  text-capitalize">
                                    सुची आमच्या वाटप केंद्रावरून घ्यायची असल्यास
                                </span>
                                {/* <label className="form-check-label" htmlFor="inlineRadio2">सुची आमच्या वाटप केंद्रावरून घ्यायची असल्यास</label> */}
                                <br></br> टीप :-
                                <div className="text-primary ">
                                    1) आपल्याला वधू वर सूची मिळण्यासाठी तुम्हाला योग्य अशा सूची वाटप केंद्राची निवड करावी म्हणजे तुम्ही निवड केलेल्या वधू वर सूची वाटप केंद्रावर तुमची सूची ठेवण्यात येईल.<br></br>
                                    2)सुचिचे पेमेंट आपण खालीलपैकी निवडलेल्या वाटप केंद्रावर पण करून सुची घेऊ शकतात किंवा आताच ऑनलाईन केले तर तुम्हाला खात्रीने सुची देता येणे शक्य होईल.
                                </div>
                                {this.state.pickup ?
                                    <div className="col-md-12 bg-white p-lg-4 " id='pickup' >

                                        <form className="row g-3">

                                            <div className="col-md-3">
                                                <label htmlFor="inputEmail4" className="form-label">* राज्य  </label>
                                                {/* <input type="text"   value={this.state.sbg_post_state}  onChange={this.stateHandler} className="form-control" id="sbg_post_state" /> */}
                                                <select id="sbg_post_state1" value={this.state.sbg_post_state1} onChange={this.stateHandler1} className="form-select">
                                                    <option value="f" selected >Select State</option>
                                                    {stateList1}
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="inputEmail4" className="form-label">* जिल्हा  </label>

                                                {/* <input type="text"   value={this.state.sbg_post_district}  onChange={this.districtHandler} className="form-control" id="sbg_post_district" /> */}
                                                <select id="sbg_post_district1" value={this.state.sbg_post_district1} onChange={this.districtHandler1} className="form-select">
                                                    <option value="f" selected >Select District</option>
                                                    {districtList1}
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label htmlFor="inputEmail4" className="form-label">* तालुका  </label>

                                                {/* <input type="text"   value={this.state.sbg_post_taluka}  onChange={this.talukaHandler} className="form-control" id="sbg_post_taluka" /> */}
                                                <select id="sbg_post_taluka1" value={this.state.sbg_post_taluka1} onChange={this.talukaHandler1} className="form-select">
                                                    <option value="f" selected >Select Taluka</option>
                                                    {talukaList1}
                                                </select>
                                            </div><br></br>
                                            {this.state.selectedSuchi ? <div className="col-md-12">
                                                <label htmlFor="inputEmail4" className="form-label"><b>निवडलेले सूची वाटप केंद्र </b> </label>
                                                <table class="table bg-white"> <tr>
                                                    <td width='20%'>{this.state.scc_name}</td>
                                                    <td width='20%'>{this.state.scc_person_name}</td>
                                                    <td width='20%'>{this.state.scc_mobile_no1}</td>
                                                    <td width='10%'><a href='{this.state.scc_map_link}'>Google Map</a></td>
                                                    <td width='40%'>{this.state.scc_address}</td>
                                                </tr></table>
                                                .
                                            </div>
                                                : ''}
                                            <div className="col-md-12">

                                                <label htmlFor="inputEmail4" className="form-label">* सूची वाटप केंद्र  </label>

                                                <span className='text-danger' id="sbg_post_collection1"></span>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <td width='20%'>Centre Name</td>
                                                                <td width='20%'>Person Name</td>
                                                                <td width='20%'>Mobile No.</td>
                                                                <td width='10%'>Map Link</td>
                                                                <td width='40%'>Address</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {collectionList}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                            <div className="col-12">
                                                <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick1) ? this.submitClick1(e) : null}>Save 📁</button>
                                                <br></br>  <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                                            </div>
                                        </form>
                                    </div>
                                    : ''}
                            </div>
                            {this.state.suchi_fee_status === "1" ?
                                <div className="form-check form-check-inline  col-md-12 ">
                                    <hr></hr>
                                    <input className="form-check-input" type="radio"
                                        name="selectType" value="courier"
                                        onChange={this.typeHandler} id="inlineRadio1"
                                        style={{
                                            appearance: "none", // remove default radio styling
                                            WebkitAppearance: "none",
                                            MozAppearance: "none",
                                            width: "20px",
                                            height: "20px",
                                            border: "2px solid #000", // dark border
                                            borderRadius: "50%",
                                            outline: "none",
                                            cursor: "pointer",
                                            position: "relative",
                                        }} />
                                    <span className="d-block p-2 bg-secondary text-white  text-capitalize">
                                        सुची कुरियर ने घरपोच हवी असल्यास
                                    </span>

                                    टीप :
                                    <div className="text-primary ">

                                        1)कूरियर किंवा पोस्टाने सूची घरपोच पाठवायची झाल्यास आपला सविस्तर पत्ता येथे देऊन ठेवावा. संपूर्ण नाव , घर क्रमांक ,
                                        बिल्डिंग चे नाव , गल्ली , नगर, रोड, गाव , तालुका , जिल्हा , पिन कोड असा सविस्तर पत्ता टाकावा .<br></br>
                                        2)खाली माहिती भरतांना आपले जिल्हा , तालुका, गाव येत नसेल तर सध्याला सर्व ठिकाणी OTHER  हा पर्याय निवडून खालील बॉक्स मध्ये तुमचा संपूर्ण पत्ता बिनचूकपणे पिन कोड सहित टाकावा आणि ऑफिस ला कॉल करून कळवावे.
                                        कुरियर घरपोच येण्यासाठी  सविस्तर पत्ता पिन कोड सहित लिहावा

                                        <br></br>
                                        <b>सुची कुरियर ने मागविण्यासाठी
                                            ({this.state.suchi_fee_status == 1 ? 'सुची फी ' + this.state.suchi_suchi_fee + '/- आणि' : ''} कुरियर खर्च {this.state.suchi_curier_fee}/- )भरणे आवश्यक आहे</b> <br></br><br></br>
                                        <b>ज्या वधू-वरांना जळगाव जिल्हा , बुलढाणा , मलकापुर, मोताळा, नांदुरा परिसरात सूची पाहिजे आहे त्यांना कूरियर व्यवस्था उपलब्ध नाही. त्यांनी त्यांच्या परिसरातील लेवा शुभमंगल सूची वाटप केंद्र निवडावे.</b><br />
                                    </div>

                                    {this.state.courier ?
                                        <div id='courior' className='col-md-12'>

                                            <form className="row g-3">

                                                <div className="col-md-8"> <br></br>
                                                    <label htmlFor="inputEmail4" className="form-label">* पूर्ण नाव </label>
                                                    <input type="text" maxLength="60" value={this.state.sbg_post_full_name}
                                                        onChange={this.nameHandler} className="form-control" id="sbg_post_full_name" lang="mr" />
                                                </div>
                                                <div className="col-md-4"> <br></br>
                                                    <label htmlFor="inputEmail4" className="form-label">* मोबाईल क्रमांक</label>
                                                    <input type="text" value={this.state.sbg_post_mobileno} maxLength="13" onChange={this.mobileHandler} className="form-control" id="sbg_post_mobileno" />

                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="inputEmail4" className="form-label">* पिन कोड </label>
                                                    <input type="text" maxLength="60" value={this.state.sbg_post_pincode} onChange={this.pincodeHandler} className="form-control" id="sbg_post_pincode" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="inputEmail4" className="form-label">* राज्य  </label>
                                                    {/* <input type="text"   value={this.state.sbg_post_state}  onChange={this.stateHandler} className="form-control" id="sbg_post_state" />*/}
                                                    <select id="sbg_post_state" value={this.state.sbg_post_state} onChange={this.stateHandler} className="form-select">
                                                        <option value="f" selected >Select State</option>
                                                        {stateList}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="inputEmail4" className="form-label">* जिल्हा  </label>
                                                    <select id="sbg_post_district" value={this.state.sbg_post_district} onChange={this.districtHandler} className="form-select">
                                                        <option value="f" selected >Select District</option>
                                                        {districtList}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="inputEmail4" className="form-label">* तालुका  </label>
                                                    <select id="sbg_post_taluka" value={this.state.sbg_post_taluka} onChange={this.talukaHandler} className="form-select">
                                                        <option value="f" selected >Select Taluka</option>
                                                        {talukaList}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="inputEmail4" className="form-label">* गाव  </label>
                                                    <select id="sbg_post_place" value={this.state.sbg_post_place} onChange={this.placeHandler} className="form-select">
                                                        <option value="f" selected >Select Place</option>
                                                        {placeList}
                                                    </select>
                                                </div>
                                                <div className="col-md-12">

                                                    <label htmlFor="inputEmail4" className="form-label">* संपूर्ण पत्ता </label>
                                                    <textarea value={this.state.sbg_post_full_address} maxLength="150" onChange={this.addHandler} className="form-control" id="sbg_post_full_address" placeholder="कृपया पत्ता व्यवस्थित लिहावा" />

                                                </div>
                                                <div className="col-12">
                                                    <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save 📁</button>
                                                    <br></br>  <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                                                </div>
                                            </form>
                                        </div>
                                        : ''}

                                </div> : ''}

                            {/* checked={this.state.sbg_suchi_delivery_type === '0'}  */}

                            <div className="form-check form-check-inline  col-md-12    ">
                                <hr></hr>
                                <input className="form-check-input" type="radio" name="selectType" value="notNow" onChange={this.typeHandler} id="inlineRadio3" />
                                <span className="d-block p-2 bg-secondary text-white  text-capitalize">
                                    Not Now
                                </span>
                                {/* <label className="form-check-label" htmlFor="inlineRadio2">Not Now</label> */}
                                <div className="text-primary ">
                                    टीप :- तुम्हाला आता च सुची घेण्यासाठी चा पर्याय निवडायचा नसेल तर स्कीप बटन दाबावे.
                                    त्यानंतर आपल्याला सुची हवी असल्यास फायनल लिस्ट तयार होई पर्यंत वरील दोन पर्यायांपैकी कोणत्याही पर्याय निवडू शकतात. निवडल्यावर कॉल करणे आवश्यक आहे.<br></br>
                                </div>
                                {this.state.notNow ?
                                    <div className="m-5 pt-3" id='pickup' >

                                        <form className="row g-3">


                                            <div className="col-12">
                                                <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitSkip) ? this.submitSkip(e) : null}>Skip 📁</button>
                                                <br></br>  <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                                            </div>
                                        </form>
                                    </div> : ''}
                            </div>
                        </div>

                    </div>

                </div>
            </>
        )
    }
}

export default PostAddress
